import baseAPI from '@/api/base';
import { EditPosition, GetPosition, RegisterPosition } from '@/dtos/position.dto';
import {
  DELETE_POSITION_URL,
  EDIT_POSITION_URL,
  GET_POSITION_IMPACT_URL,
  GET_POSITION_URL,
  REGISTER_POSITION_URL,
  TOGGLE_POSITION_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Position {
  static getPositions = async (params: GetPosition): Promise<AxiosResponse> =>
    baseAPI.get(GET_POSITION_URL, { params });

  static getPositionImpact = async (params: { id: string }): Promise<AxiosResponse> =>
    baseAPI.get(GET_POSITION_IMPACT_URL, { params });

  static registerPosition = async (payload: RegisterPosition): Promise<AxiosResponse> =>
    baseAPI.post(REGISTER_POSITION_URL, { ...payload });

  static editPosition = async (payload: EditPosition): Promise<AxiosResponse> =>
    baseAPI.put(EDIT_POSITION_URL, { ...payload });

  static togglePositionIsActive = async (payload: { id: string }): Promise<AxiosResponse> =>
    baseAPI.patch(TOGGLE_POSITION_IS_ACTIVE_URL, { ...payload });

  static deletePosition = async (id: string): Promise<AxiosResponse> =>
    baseAPI.delete(`${DELETE_POSITION_URL}/${id}`);
}

export default Position;
